import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function PropertyButton({ name, code, kind = 'person', compact = false, testid }) {
  const navigate = useNavigate();
  const go = () => navigate(`/portal/immobili?${new URLSearchParams({ name: name || '', code: code || '', kind })}`);
  if (compact) {
    return (
      <button onClick={go} title="Report Immobiliare" className="shrink-0 h-8 px-2.5 inline-flex items-center gap-1.5 border border-[#1F242C] rounded-sm text-xs text-[#C9CCD1] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors" data-testid={testid}>
        <Home size={13} />Immobili
      </button>
    );
  }
  return (
    <button onClick={go} className="h-10 px-4 inline-flex items-center gap-2 border border-[#1F242C] rounded-sm text-sm text-[#E5E5E5] hover:border-[#D4AF37] transition-colors" data-testid={testid}>
      <Home size={15} />Report Immobiliare
    </button>
  );
}
